import { render, staticRenderFns } from "./FilterSidebar.vue?vue&type=template&id=0c6a5189"
import script from "./FilterSidebar.vue?vue&type=script&lang=js"
export * from "./FilterSidebar.vue?vue&type=script&lang=js"
import style0 from "./FilterSidebar.vue?vue&type=style&index=0&id=0c6a5189&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports